import React, { Component } from 'react';
import {toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {ValidateState} from '../../../functions'; 
import {API_URL} from '../../../constants';
import {updateValueInJson, validateAccesoGeneral, getRoles} from '../../../functions';
import axios from 'axios';
import $ from 'jquery';

export default class AgregarOficinaMundo extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            nombreLongitud:0,
            contactoLongitud:0,
            resource: {
                omun_Nombre:"",
                omun_Contacto:"",
                omun_Telefono:"",
                omun_Direccion:"",
                omun_Latitud:"",
                omun_Longitud:"",
                omun_Correo:"",
                omun_Orden:this.props.location.state !== undefined ? this.props.location.state.totalRegistros + 1 : "",
                omun_Activo:true
            },
            Validacion: {
                omun_Nombre: {
                    Error: false,                    
                },
                omun_Contacto: {
                    Error: false,                    
                },
                omun_Telefono: {
                    Error: false,                    
                },
                omun_Direccion: {
                    Error: false,                    
                },
                omun_Latitud: {
                    Error: false,                    
                },
                omun_Longitud: {
                    Error: false,                    
                },
                omun_Correo: {
                    Error: false,                    
                },
                omun_Orden: {
                    Error: false,                    
                }
            },
            hasError:false,    
            hasErrorProceso:false,        
            added: false,
            security: cookie.load('user'),
            roles: [],
            agrupador:"",
            menuGeneral:[]
          }
        this.handleInputChange = this.handleInputChange.bind(this);

      }

    componentDidMount()
    {
        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/oficinas-mundo";

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        validateAccesoGeneral(locationState, pathNameList, rol); 
    }
    
    handleClickCancel(e) {

        e.preventDefault();

        const {history: {push}} = this.props;    
        push('/oficinas-mundo');
     }

     callFunctionButton = (event) => {

        event.preventDefault();

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.omun_Nombre == '') {              
            newState.Validacion.omun_Nombre = {Error: true};
            newState.hasError = true;
        }
        /*
            if (newState.resource.omun_Contacto == '') {  
                newState.Validacion.omun_Contacto = {Error: true};
                newState.hasError = true;
            }
            if (newState.resource.omun_Telefono == '') {  
                newState.Validacion.omun_Telefono = {Error: true};
                newState.hasError = true;
            }
            if (newState.resource.omun_Direccion == 0) {  
                newState.Validacion.omun_Direccion = {Error: true};
                newState.hasError = true;
            }
        */
        if (newState.resource.omun_Latitud == 0) {  
            newState.Validacion.omun_Latitud = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.omun_Longitud == 0) {  
            newState.Validacion.omun_Longitud = {Error: true};
            newState.hasError = true;
        }

        /*
            if (newState.resource.omun_Correo == 0) {  
                newState.Validacion.omun_Correo = {Error: true};
                newState.hasError = true;
            }
        */

        if (newState.resource.omun_Orden == '') {  
            newState.Validacion.omun_Orden = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}OficinaMundoUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'omun_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),{ 
            headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }).then((data)=> {             
            
            if (data.data.isSucess){
                
                let stateResponse = this.state;

                stateResponse.added = true;
                stateResponse.resource.omun_Nombre = '';
                stateResponse.resource.omun_Contacto = '';
                stateResponse.resource.omun_Telefono = '';
                stateResponse.resource.omun_Direccion = '';
                stateResponse.resource.omun_Latitud = '';
                stateResponse.resource.omun_Longitud = '';
                stateResponse.resource.omun_Correo = '';
                stateResponse.resource.omun_Orden += 1 ;

                this.setState(stateResponse);
                setTimeout(() => {
                    this.props.history.push({
                        pathname: '/oficinas-mundo',
                    });
                }, 1500);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        toast.error('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let nombreLongitud = this.state.nombreLongitud;
        let contactoLongitud = this.state.contactoLongitud;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'omun_Nombre'){
            nombreLongitud = value.length;
        }
        if(target.name == 'omun_Contacto'){
            contactoLongitud = value.length;
        }
        this.setState({
            resource: copyResource,
            nombreLongitud: nombreLongitud,
            contactoLongitud: contactoLongitud,
            Validacion: validaciones
        });  
    }

    render() {
        return (
            <div class="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de configuración general
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Agregar Oficina Mundo</span>
                    </div>
                </div>

                <div className="divTitulo_Panel">
                    Agregar Oficina Mundo
                </div>

                {this.state.hasErrorProceso ? 
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar el registro.</div>
                        </div>
                    </div> 
                    : 
                    null
                }   

                {this.state.added ? 
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se realizó el registro correctamente.</div>
                        </div>
                    </div>
                    : 
                    null
                }             
                
                <div className="div_Modulos_Noticias">
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Título" name='omun_Nombre' value={this.state.resource.omun_Nombre} maxLength={220} className={this.state.Validacion.omun_Nombre.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                        <span data-length={220}>{this.state.nombreLongitud}/220</span>
                    </div>

                    <div className="txtFile x-1">
                        <input type="text" placeholder="Descripción" name='omun_Contacto' value={this.state.resource.omun_Contacto} maxLength={220} className={this.state.Validacion.omun_Contacto.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                        <span data-length={220}>{this.state.contactoLongitud}/220</span>
                    </div>

                    <div className="txtFile x-1">
                        <input type="text" placeholder="Teléfono" name='omun_Telefono' value={this.state.resource.omun_Telefono} className={this.state.Validacion.omun_Telefono.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                        <input type="text" placeholder="Dirección" name='omun_Direccion' value={this.state.resource.omun_Direccion} className={this.state.Validacion.omun_Direccion.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                        <input type="text" placeholder="Latitud" name='omun_Latitud' value={this.state.resource.omun_Latitud} className={this.state.Validacion.omun_Latitud.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                        <input type="text" placeholder="Longitud" name='omun_Longitud' value={this.state.resource.omun_Longitud} className={this.state.Validacion.omun_Longitud.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                        <input type="text" placeholder="Correo" name='omun_Correo' value={this.state.resource.omun_Correo} className={this.state.Validacion.omun_Correo.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-2">
                        <input type="text" placeholder="Orden" name='omun_Orden' value={this.state.resource.omun_Orden} maxLength={2} className={this.state.Validacion.omun_Orden.Error ? "error" : ""} onChange={this.handleInputChange} onChange={this.handleInputChange}/>
                    </div>

                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo"  onClick={(event) => this.callFunctionButton(event)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />

            </div>
        )
    }
}